import type { Component } from "vue";

import { ApiIcon, CommandCenterIcon, ForwardingIcon, TextFieldIcon } from "~/icons";
import { ExecutionMode } from "~/shared/enums";

const EXECUTION_MODE_DISPLAY: Record<ExecutionMode, { label: string; description: string; icon: Component }> = {
  [ExecutionMode.PROMPT]: {
    label: "Instructions",
    description: "Follows a natural language description of how to behave",
    icon: TextFieldIcon,
  },
  [ExecutionMode.API]: {
    label: "Forwarding",
    description: "Makes API requests to forward information when it is triggered",
    icon: ForwardingIcon,
  },
  [ExecutionMode.LOCAL]: {
    label: "Local",
    description: "Runs on your machine via the Dart agent CLI",
    icon: CommandCenterIcon,
  },
  [ExecutionMode.NONE]: {
    label: "API only",
    description: "Takes no action on its own and is only driven externally",
    icon: ApiIcon,
  },
};

export default EXECUTION_MODE_DISPLAY;
